import { combineReducers } from 'redux';
import bookingList from './BookingListReducer';

const rootReducer = combineReducers({
  bookingList,
});

export default rootReducer;
